import React from 'react'
import { useSalesTokenCompaniesLogic } from '../../hooks/Admin/useSalesTokenCompaniesLogic'

function SalesTokenCompanies({ salesTokenSite }){
    const {
        getCompaniesForSalesToken
    } = useSalesTokenCompaniesLogic()

    const organizations = getCompaniesForSalesToken(salesTokenSite.sitePath)
    
    return <>
        <h3>Connected Companies</h3><br />
        <div class="table-responsive plr-10">
            <table className="table table-hover">
                <thead>
                    <tr>
                        <th>Company Name</th>
                    </tr>
                </thead>
                <tbody>
                    {organizations?.length ? organizations.map(org => <tr>
                        <td>{org.name}</td>
                    </tr>) : <tr>
                        <td className="text-center">No companies found</td>
                    </tr>}
                </tbody>
            </table>
        </div>
    </>
}

export default SalesTokenCompanies